import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'transferSvgIcon',
  props: {
    color: {},
    width: {},
    height: {},
    fill: {},
    stroke: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M14.7196 2H4.90152C3.96864 2 3.2124 2.75624 3.2124 3.68911V14.9472C3.2124 15.8801 3.96864 16.6363 4.90152 16.6363H14.7196C15.6525 16.6363 16.4087 15.8801 16.4087 14.9472V3.68911C16.4087 2.75624 15.6525 2 14.7196 2Z",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M17 5.53626V8.53625H19V5.53626H17Z",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M1 5.53626L1 8.53625H3V5.53626H1Z",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M16.4087 4.81915H3.2124V11.1941H16.4087V4.81915Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M12.2344 16.7516H14.5422V17.9717C14.5422 18.5798 14.048 19.0726 13.4413 19.0726H13.3366C12.7285 19.0726 12.2357 18.5785 12.2357 17.9717V16.7516H12.2344Z",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M5.0166 16.7516H7.3244V17.9717C7.3244 18.5798 6.83025 19.0726 6.22349 19.0726H6.11883C5.51075 19.0726 5.01793 18.5785 5.01793 17.9717V16.7516H5.0166Z",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_7),
    _cache[0] || (_cache[0] = _createElementVNode("path", {
      d: "M9.81104 4.36609V11.7134",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1)),
    _createElementVNode("path", {
      d: "M8.77783 13.7086H10.8737",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M6.04206 14.9181C6.71007 14.9181 7.2516 14.3766 7.2516 13.7086C7.2516 13.0406 6.71007 12.499 6.04206 12.499C5.37405 12.499 4.83252 13.0406 4.83252 13.7086C4.83252 14.3766 5.37405 14.9181 6.04206 14.9181Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M13.6094 14.9181C14.2775 14.9181 14.819 14.3766 14.819 13.7086C14.819 13.0406 14.2775 12.499 13.6094 12.499C12.9414 12.499 12.3999 13.0406 12.3999 13.7086C12.3999 14.3766 12.9414 14.9181 13.6094 14.9181Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_10)
  ], 8, _hoisted_1))
}
}

})